module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-button-wide-62ae80bb.svg";